export default __webpack_public_path__ + "static/media/NunitoSans-Light.7f9eed4c.ttf";